import {LookupService} from '../../common/service/lookup.service';
import {DisplayPreferencesService} from '../../common/service/display-preferences.service';
import {MapModeService} from './map-mode.service';
import {WidgetService} from './widget.service';
import {SettingsModalService} from '../../common/component/modal';
import {MapToolsService} from './map-tools.service';
import {GraphicSelectionService} from './graphic-selection.service';
import {SpatialUtilService} from './spatial-util.service';
import {PlanModelService} from '../../common/service/plan-model.service';
import {Injectable} from '@angular/core';
import {PermissionsService} from '../../common/service/permissions.service';
import {NgEventBus} from 'ng-event-bus';
import {AttributeViewerService} from '../widgets/attribute-viewer/attribute-viewer.service';
import {MapService} from './map.service';
import {FeaturesDeletionService} from './features-deletion.service';
import {forkJoinDefaultIfEmpty} from '../../common/observable.utils';
import {VisibilitySettingsService} from './visibility-settings.service';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-escape */
@Injectable({
    providedIn: 'root'
})
export class RibbonService {
    constructor(
        private featuresDeletionService: FeaturesDeletionService,
        private lookupService: LookupService,
        private displayPreferencesService: DisplayPreferencesService,
        private attributeViewerService: AttributeViewerService,
        private mapModeService: MapModeService,
        private widgetService: WidgetService,
        private settingsModalService: SettingsModalService,
        private mapToolsService: MapToolsService,
        private mapService: MapService,
        private permissionService: PermissionsService,
        private graphicSelectionService: GraphicSelectionService,
        private spatialUtilService: SpatialUtilService,
        private planModelService: PlanModelService,
        private eventBus: NgEventBus,
        private visibilitySettingsService: VisibilitySettingsService
    ) {}

    title = 'RibbonService';

    private deleteAllSelectedFeaturesTimer: any;
    displayPreferencesChanged(preferences) {
        console.debug(this.title + ' : displayPreferencesChanged');
        this.displayPreferencesService.displayPreferencesChanged(preferences);
        this.mapModeService.updateMapMode();
    }

    canFeatureBeHidden(featureLayer, feature, mapMode) {
        const featureLayerType = this.spatialUtilService.getFeatureLayerName(featureLayer);

        const featureAttributeLookup = this.lookupService
            .getLookups('featureAttributes')
            .find(l => l.featureType === featureLayerType && l.prop === 'type' && l.lookupService);
        if (!featureAttributeLookup) {
            return true;
        }

        const lookupServiceLookup = this.lookupService.getLookups(featureAttributeLookup.lookupService).find(l => l.id === feature.attributes.type);
        if (!lookupServiceLookup) {
            return true;
        }

        if (mapMode === 'mainPlan') {
            return Object.hasOwn(lookupServiceLookup, 'hideNotPermittedMainPlan')
                ? !lookupServiceLookup.hideNotPermittedMainPlan
                : this.visibilitySettingsService.applyVisibilityThisPageOnly;
        }

        return Object.hasOwn(lookupServiceLookup, 'hideNotPermittedEnlargements')
            ? !lookupServiceLookup.hideNotPermittedEnlargements
            : this.visibilitySettingsService.applyVisibilityThisPageOnly;
    }

    shouldRelatedAnnotationsVisibilityMatchFeature(featureLayer, feature) {
        const featureLayerType = this.spatialUtilService.getFeatureLayerName(featureLayer);
        const featureType =
            (featureLayerType === 'constructPoint' && 'point') || (featureLayerType === 'constructLine' && 'line') || featureLayerType;

        const featureAttributeLookup = this.lookupService
            .getLookups('featureAttributes')
            .find(l => l.featureType === featureType && l.prop === 'type' && l.lookupService);
        if (!featureAttributeLookup) {
            return false;
        }

        let lookupServiceLookup = this.lookupService.getLookups(featureAttributeLookup.lookupService).find(l => l.id === feature.attributes.type);

        if (!lookupServiceLookup) {
            if (featureLayer.id === 'controlPointFeatureLayer') {
                lookupServiceLookup = this.lookupService.getLookups('controlPointTypeLookups').find(l => l.id === feature.attributes.type);
            }

            if (!lookupServiceLookup) {
                return false;
            }
        }

        return Object.hasOwn(lookupServiceLookup, 'autoHideUnhideAnnotation') && lookupServiceLookup.autoHideUnhideAnnotation;
    }

    updateVisibilityAttributes(featureLayer, feature, visible, enlargementIds, currentEnlargementId) {
        if (this.mapModeService.isMapModeType('mainPlan')) {
            feature.attributes.visible = visible ? 'YES' : 'NO';
        } else {
            if (Object.hasOwn(feature.attributes, 'enlargementid')) {
                // angles/annotations
                if (feature.attributes.enlargementid) {
                    feature.attributes.visible = null;
                    feature.attributes.hiddenonenlargements = visible ? null : `[${feature.attributes.enlargementid}]`;
                } else {
                    // When AcrossAllPages is selected and enlargement is MainPlan
                    if (!this.visibilitySettingsService.applyVisibilityThisPageOnly && this.canFeatureBeHidden(featureLayer, feature, 'mainPlan')) {
                        feature.attributes.visible = visible ? 'YES' : 'NO';
                    }
                }
            } else {
                // when AcrossAllPages is selected and hide a feature that are NOT Angle and NOT Annotation
                if (!this.visibilitySettingsService.applyVisibilityThisPageOnly && this.canFeatureBeHidden(featureLayer, feature, 'mainPlan')) {
                    feature.attributes.visible = visible ? 'YES' : 'NO';
                }
            }
        }

        if (Object.hasOwn(feature.attributes, 'hiddenonenlargements')) {
            const hiddenOnEnlargementIds = feature.attributes.hiddenonenlargements
                ? feature.attributes.hiddenonenlargements
                      .replace(/[\[\]]/g, '')
                      .split(',')
                      .map(s => parseInt(s, 10))
                      .filter(id => enlargementIds.includes(id) && (this.mapModeService.isMapModeType('mainPlan') || id !== currentEnlargementId))
                      .reduce((acc, id) => {
                          if (!acc.includes(id)) {
                              acc.push(id);
                          }
                          return acc;
                      }, [])
                : [];

            if (this.visibilitySettingsService.applyVisibilityThisPageOnly) {
                //Current page
                if (!this.mapModeService.isMapModeType('mainPlan') && !visible) {
                    hiddenOnEnlargementIds.push(currentEnlargementId);
                }
            } else {
                //All pages
                hiddenOnEnlargementIds.length = 0;
                if (!visible) {
                    hiddenOnEnlargementIds.push(...enlargementIds);
                }
            }

            hiddenOnEnlargementIds.sort((a, b) => a - b);

            feature.attributes.hiddenonenlargements = hiddenOnEnlargementIds.length ? hiddenOnEnlargementIds.map(v => `[${v}]`).join() : null;
        }
    }

    setConstructionToolsVisibility(enabled) {
        this.widgetService.setWidgetDisabled('ConstructionTools', !enabled);
    }

    printToPdf() {
        console.debug(this.title + ' : printToPdf');

        if (this.planModelService.getModel().pdfCreationMethod === 'CAD_SOFTWARE') {
            return;
        }
        this.settingsModalService
            .showModal({
                spatialReference: this.mapService.map.spatialReference,
                // Restricting access based on permissions appears to be superfluous due of previous checks, but we do it anyway
                accessRestriction: this.planModelService.readonly || !this.permissionService.hasEditPermission(['EDIT_PLAN'])
            })
            .subscribe();
    }

    selectAllFeatures() {
        console.debug(this.title + ' : selectAllFeatures');
        this.spatialUtilService.unhighlightAllGeometryFeatures();

        this.attributeViewerService.unhighlightFeaturesOutOfContextAllowed(false);

        this.graphicSelectionService.featureLayers.forEach(featureLayer => {
            const features = this.spatialUtilService.getGraphics(featureLayer);
            const featureLayerName = featureLayer.id.substring(0, featureLayer.id.indexOf('FeatureLayer')).toLowerCase();
            const filteredFeatures = this.graphicSelectionService.applyFeaturesFilter(featureLayerName, features);
            this.spatialUtilService.highlightFeatures(featureLayer, filteredFeatures);
        });
    }

    clearSelectedFeatures() {
        console.debug(this.title + ' : clearSelectedFeatures');

        this.spatialUtilService.unhighlightAllFeatures();

        this.mapService.clearGraphicToModify();
        this.eventBus.cast('clearSelectedFeatures');
    }

    removalActionsAreDisabled() {
        //pass readOnly?
        return this.planModelService.readonly || this.widgetService.isWidgetDisabled();
    }

    deleteAllSelectedFeatures() {
        if (this.removalActionsAreDisabled()) {
            return;
        }

        console.debug(this.title + ' : deleteAllSelectedFeatures');

        if (this.deleteAllSelectedFeaturesTimer) {
            clearTimeout(this.deleteAllSelectedFeaturesTimer);
        }

        this.deleteAllSelectedFeaturesTimer = setTimeout(() => this.featuresDeletionService.deleteFeatures().subscribe(), 100);
    }

    showFeatures(visible) {
        console.debug(`${this.title} : showFeatures`);

        const enlargementIds = this.mapModeService.mapModeList.slice(1).map(item => item.id);

        const highlightedFeatureSets = [];
        const typeIdFeatureMap = {};

        this.spatialUtilService.getHighlightedFeatureSets().forEach(s => {
            const features = s.graphics.filter(
                g => Object.hasOwn(g.attributes, 'visible') && this.canFeatureBeHidden(s.featureLayer, g, this.mapModeService.mapMode.type)
            );
            if (features.length === 0) {
                return;
            }

            highlightedFeatureSets.push({features: features, featureLayer: s.featureLayer});

            const featuresWithRelatedAnnotationsToHide = [];
            features.forEach(feature => {
                this.updateVisibilityAttributes(s.featureLayer, feature, visible, enlargementIds, this.mapModeService.mapMode.id);

                if (this.shouldRelatedAnnotationsVisibilityMatchFeature(s.featureLayer, feature)) {
                    featuresWithRelatedAnnotationsToHide.push(feature);
                }
            });

            if (featuresWithRelatedAnnotationsToHide.length) {
                const featureLayerType = this.spatialUtilService.getFeatureLayerName(s.featureLayer);

                if (!typeIdFeatureMap[featureLayerType]) {
                    typeIdFeatureMap[featureLayerType] = {};
                }

                featuresWithRelatedAnnotationsToHide.forEach(f => (typeIdFeatureMap[featureLayerType][f.attributes.id] = f));
            }
        });

        //
        // TODO: Assumption was made: Expecting hideNotPermittedMainPlan to be true before hideNotPermittedEnlargements to be true
        // Now adding a case that does the opposite
        // TODO: Need revisit

        const featureAttributeLookups = this.lookupService.getLookups('featureAttributes');
        this.spatialUtilService.getHighlightedFeatureSets().forEach(s => {
            const features = s.graphics.filter(g => {
                const featureLayerType = this.spatialUtilService.getFeatureLayerName(s.featureLayer);
                const featureAttributeLookup = featureAttributeLookups.find(
                    l => l.featureType === featureLayerType && l.prop === 'type' && l.lookupService
                );
                if (featureAttributeLookup) {
                    const lookupServiceLookup = this.lookupService
                        .getLookups(featureAttributeLookup.lookupService)
                        .find(l => l.id === g.attributes.type);
                    if (lookupServiceLookup) {
                        if (this.mapModeService.mapMode.type === 'mainPlan' && this.visibilitySettingsService.applyVisibilityThisPageOnly) {
                            // eslint-disable-next-line max-len
                            return Object.hasOwn(lookupServiceLookup, 'hideNotPermittedMainPlan') && !lookupServiceLookup.hideNotPermittedMainPlan;
                        } else {
                            return Object.hasOwn(lookupServiceLookup, 'hideNotPermittedEnlargements')
                                ? !lookupServiceLookup.hideNotPermittedEnlargements
                                : this.visibilitySettingsService.applyVisibilityThisPageOnly;
                        }
                    }
                }
                return false;
            });

            if (features.length === 0) {
                return;
            }
            highlightedFeatureSets.push({features: features, featureLayer: s.featureLayer});
            const featuresWithRelatedAnnotationsToHide = [];
            features.forEach(feature => {
                if (Object.hasOwn(feature.attributes, 'hiddenonenlargements')) {
                    const hiddenOnEnlargementIds = feature.attributes.hiddenonenlargements
                        ? feature.attributes.hiddenonenlargements
                              .replace(/[\[\]]/g, '')
                              .split(',')
                              .map(s => parseInt(s, 10))
                              .filter(
                                  id =>
                                      enlargementIds.includes(id) &&
                                      (this.mapModeService.isMapModeType('mainPlan') || id !== this.mapModeService.mapMode.id)
                              )
                              .reduce((acc, id) => {
                                  if (!acc.includes(id)) {
                                      acc.push(id);
                                  }
                                  return acc;
                              }, [])
                        : [];

                    if (this.visibilitySettingsService.applyVisibilityThisPageOnly) {
                        //Current page
                        if (!this.mapModeService.isMapModeType('mainPlan') && !visible) {
                            hiddenOnEnlargementIds.push(this.mapModeService.mapMode.id);
                        }
                    } else {
                        //All pages
                        hiddenOnEnlargementIds.length = 0;
                        if (!visible) {
                            hiddenOnEnlargementIds.push(...enlargementIds);
                        }
                    }
                    hiddenOnEnlargementIds.sort((a, b) => a - b);
                    feature.attributes.hiddenonenlargements = hiddenOnEnlargementIds.length ? hiddenOnEnlargementIds.map(v => `[${v}]`).join() : null;
                }
                if (this.shouldRelatedAnnotationsVisibilityMatchFeature(s.featureLayer, feature)) {
                    featuresWithRelatedAnnotationsToHide.push(feature);
                }
            });

            if (featuresWithRelatedAnnotationsToHide.length) {
                const featureLayerType = this.spatialUtilService.getFeatureLayerName(s.featureLayer);
                if (!typeIdFeatureMap[featureLayerType]) {
                    typeIdFeatureMap[featureLayerType] = {};
                }
                featuresWithRelatedAnnotationsToHide.forEach(f => (typeIdFeatureMap[featureLayerType][f.attributes.id] = f));
            }
        });
        ////////////////// END

        //Get annotations related to selected non-annotation features
        if (Object.keys(typeIdFeatureMap).length) {
            const typeIdsMap = Object.keys(typeIdFeatureMap).reduce((acc, k) => {
                acc[k] = Object.keys(typeIdFeatureMap[k]).map(id => parseInt(id, 10));
                return acc;
            }, {});

            const relatedAnnotations = this.spatialUtilService.getAnnotations().filter(f =>
                Object.keys(typeIdsMap).some(
                    k =>
                        ((k === f.attributes.featuretype && typeIdsMap[k].includes(f.attributes.featureid)) ||
                            (f.attributes.featuretype === 'interest' &&
                                typeIdsMap[k].includes(f.attributes.childid) &&
                                this.canIncludeAnnotation(
                                    featureAttributeLookups,
                                    f.attributes.childtype == 'polyline' ? 'line' : f.attributes.childtype,
                                    f.attributes,
                                    this.spatialUtilService.getLineGraphics().filter(g => g.attributes.id === f.attributes.childid)[0].attributes.type
                                ))) && //Should check for childtype & childid for polygon & polyline associations //TODO: Need revisit
                        (!this.visibilitySettingsService.applyVisibilityThisPageOnly ||
                            (this.mapModeService.isMapModeType('mainPlan')
                                ? !f.attributes.enlargementid
                                : f.attributes.enlargementid === this.mapModeService.mapMode.id))
                )
            );

            relatedAnnotations.forEach(a =>
                this.updateVisibilityAttributes(
                    this.spatialUtilService.getFeatureLayer('annotation'),
                    a,
                    this.isVisible(typeIdFeatureMap, a, visible),
                    enlargementIds,
                    this.mapModeService.mapMode.id
                )
            );
            const annotationFeatureSet = highlightedFeatureSets.find(fs => fs.featureLayer === this.spatialUtilService.getAnnotationMapLayer());
            if (annotationFeatureSet) {
                annotationFeatureSet.features.push(...relatedAnnotations);
            } else {
                highlightedFeatureSets.push({features: relatedAnnotations, featureLayer: this.spatialUtilService.getAnnotationMapLayer()});
            }
        }

        //Get related annotations from other pages
        if (!this.visibilitySettingsService.applyVisibilityThisPageOnly) {
            const annotationFeatureSet = highlightedFeatureSets.find(fs => fs.featureLayer === this.spatialUtilService.getAnnotationMapLayer());
            if (annotationFeatureSet && annotationFeatureSet.features) {
                const allRelatedAnnotationIds = annotationFeatureSet.features.reduce((acc, a) => {
                    if (!acc.includes(a.attributes.id)) {
                        acc.push(a.attributes.id);
                    }
                    if (a.attributes.parentid && !acc.includes(a.attributes.parentid)) {
                        acc.push(a.attributes.parentid);
                    }
                    return acc;
                }, []);

                const annotationsFromOtherPages = this.spatialUtilService
                    .getAnnotations()
                    .filter(
                        f =>
                            allRelatedAnnotationIds.includes(f.attributes.id) ||
                            (f.attributes.parentid && allRelatedAnnotationIds.includes(f.attributes.parentid))
                    );

                annotationsFromOtherPages.forEach(a =>
                    this.updateVisibilityAttributes(
                        this.spatialUtilService.getFeatureLayer('annotation'),
                        a,
                        this.isVisible(typeIdFeatureMap, a, visible),
                        enlargementIds,
                        this.mapModeService.mapMode.id
                    )
                );

                annotationFeatureSet.features.push(...annotationsFromOtherPages);
            }

            const angleFeatureSet = highlightedFeatureSets.find(fs => fs.featureLayer === this.spatialUtilService.getAngleMapLayer());
            if (angleFeatureSet && angleFeatureSet.features) {
                const allAngleIds = angleFeatureSet.features.reduce((acc, a) => {
                    if (!acc.includes(a.attributes.id)) {
                        acc.push(a.attributes.id);
                    }
                    if (a.attributes.parentid && !acc.includes(a.attributes.parentid)) {
                        acc.push(a.attributes.parentid);
                    }
                    return acc;
                }, []);

                const anglesFromOtherPages = this.spatialUtilService
                    .getAngles()
                    .filter(f => allAngleIds.includes(f.attributes.id) || (f.attributes.parentid && allAngleIds.includes(f.attributes.parentid)));

                anglesFromOtherPages.forEach(a =>
                    this.updateVisibilityAttributes(
                        this.spatialUtilService.getFeatureLayer('angle'),
                        a,
                        this.isVisible(typeIdFeatureMap, a, visible),
                        enlargementIds,
                        this.mapModeService.mapMode.id
                    )
                );

                angleFeatureSet.features.push(...anglesFromOtherPages);
            }
        }
        const editObservables = highlightedFeatureSets.map(fs => this.spatialUtilService.applyEdits(fs.featureLayer, null, fs.features, null));

        return forkJoinDefaultIfEmpty(editObservables).subscribe({
            next: () => {
                this.spatialUtilService.unhighlightAllFeatures();
            },
            error: err => {
                console.error('Error applying edits:', err);
            }
        });
    }

    private isVisible(typeIdFeatureMap: object, annotationOrAngle, visible) {
        if (this.visibilitySettingsService.applyVisibilityThisPageOnly) {
            return visible;
        }

        const a = annotationOrAngle;
        if (a.attributes.featuretype && a.attributes.featureid && typeIdFeatureMap[a.attributes.featuretype]) {
            const relatedFeature = typeIdFeatureMap[a.attributes.featuretype][a.attributes.featureid];
            if (relatedFeature) {
                if (a.attributes.enlargementid) {
                    visible = !(
                        relatedFeature.attributes.hiddenonenlargements &&
                        relatedFeature.attributes.hiddenonenlargements.includes(`[${a.attributes.enlargementid}]`)
                    );
                } else {
                    visible = relatedFeature.attributes.visible !== 'NO';
                }
            }
        }

        return visible;
    }

    private canIncludeAnnotation(featureAttributeLookups, featureLayerType, attributes, type) {
        const featureAttributeLookup = featureAttributeLookups.find(l => l.featureType === featureLayerType && l.prop === 'type' && l.lookupService);
        if (featureAttributeLookup) {
            const lookupServiceLookup = this.lookupService.getLookups(featureAttributeLookup.lookupService).find(l => l.id === type);
            if (lookupServiceLookup) {
                if (
                    Object.hasOwn(lookupServiceLookup, 'hideNotPermittedMainPlan') &&
                    lookupServiceLookup.hideNotPermittedMainPlan &&
                    !attributes.enlargementid
                ) {
                    return false;
                }
                if (
                    Object.hasOwn(lookupServiceLookup, 'hideNotPermittedEnlargement') &&
                    lookupServiceLookup.hideNotPermittedEnlargement &&
                    attributes.enlargementid
                ) {
                    return false;
                }
            }
        }

        return true;
    }
}
